export default __webpack_public_path__ + "static/media/favicon.bc0bb497.png";